import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { MdLogout } from 'react-icons/md';
import { useNavigate } from 'react-router';
import { clearUser } from 'redux/slices/auth';
import { IoIosSettings } from 'react-icons/io';
import { Profil } from 'components/profil/profil';
import { accountDropDownStyle } from 'components/InitialStyle';
import { Box, ListItemIcon, Menu, MenuItem } from '@mui/material';

type Props = {
  close: any;
  anchorEl2: any;
  open2: boolean;
};
export default function MenuComponent({ anchorEl2, open2, close }: Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch(clearUser());
    navigate('/login');
  };

  return (
    <Box>
      <Menu
        anchorEl={anchorEl2}
        id='account-menu'
        open={open2}
        onClose={close}
        PaperProps={{
          elevation: 0,
          sx: accountDropDownStyle,
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <MenuItem onClick={() => setOpen(true)}>
          <ListItemIcon>
            <IoIosSettings />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <MdLogout />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      {open && <Profil open={open} close={() => setOpen(false)} />}
    </Box>
  );
}
